import React from 'react'
import * as modalTypes from './modalTypes'
import FlightInfoHeader from './header/flightInfo'
import FlightInfoHeaderGeneric from './header/flightInfoGeneric'
import FlightInfoBody from './body/flightInfo'
import MtowBody from './body/MTow'
import WeightAlertBody from './body/weightAlert'
import StationFilterHeader from './header/stationFilter'
import StationFilterBody from './body/stationFilter'
//import StationFilterBody from '../../containers/stationFilter'
import PassengerHeader from './header/passenger'
import PassengerBody from './body/passenger'
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import PassengerInboundHeader from './header/passengerInbound'
import PassengerInboundBody from './body/passengerInbound'
import PassengerInboundTerminator from './body/PassengerInboundTerminator'
import StationName from '../../containers/stationNames'
import FlightInfoTerminator from './header/FlightInfoTerminator.js'

const Parent = (props) => {

    let { handleClose, show, modalType, selectedFlightInfo, onFlightFilter, flightFilters, flightNumbers, allFlightsData, allFlights, allStations, allModels, allGatess, allGatess11 } = props
    //console.info("parent allStations allGatess", allGatess11);
    //allModels={allModels}

    let comp = (modalType) => {


        switch (modalType) {
            case modalTypes.FLIGHT_INFO:
                return {
                    header: <FlightInfoHeader selectedFlightInfo={selectedFlightInfo} />,
                    body: <FlightInfoBody selectedFlightInfo={selectedFlightInfo} />
                }

            case modalTypes.STATION_FILTER:
                return {
                    header: <StationFilterHeader />,
                    body: <StationFilterBody handleClose={handleClose} onFlightFilter = {onFlightFilter} flightFilters = {flightFilters} flightNumbers={flightNumbers} allFlights={allFlights} allStations={allStations} 
                    allModels={allModels} allGatess={allGatess} allGatess11={allGatess11}/>
                }
                case modalTypes.STATION_DROPDOWN:
                    return {
                        //header: <StationFilterHeader />,
                        body: <StationName handleClose={handleClose} onFlightFilter = {onFlightFilter} flightFilters = {flightFilters} flightNumbers={flightNumbers} allFlights={allFlights} allStations={allStations}/>
                    }
                
            case modalTypes.PASSENGER:
                return {
                    header: <div><FlightInfoHeaderGeneric selectedFlightInfo={selectedFlightInfo} direction='2'/><PassengerHeader selectedFlightInfo={selectedFlightInfo} /></div>,
                    body: <PassengerBody selectedFlightInfo={selectedFlightInfo} allFlightsData={allFlightsData} />
                }
            case modalTypes.PASSENGERINBOUND:
                    return {
                        header: <div><FlightInfoHeaderGeneric selectedFlightInfo={selectedFlightInfo} direction="1" /><PassengerInboundHeader selectedFlightInfo={selectedFlightInfo} /></div>,
                        body: <PassengerInboundBody selectedFlightInfo={selectedFlightInfo} allFlightsData={allFlightsData} />
                    }
            case modalTypes.PASSENGERTERMINATOR:
                    return {
                            header: <div><FlightInfoTerminator selectedFlightInfo={selectedFlightInfo} direction="2" /><PassengerInboundHeader selectedFlightInfo={selectedFlightInfo} /></div>, //Terminator Flight Passenger Header and Passenger Summary
                            body: <PassengerInboundTerminator selectedFlightInfo={selectedFlightInfo} allFlightsData={allFlightsData} />
                        }
                    
            case modalTypes.WEIGHT_ALERT:
                return {
                    header: <FlightInfoHeaderGeneric selectedFlightInfo={selectedFlightInfo} />,
                    body: <WeightAlertBody selectedFlightInfo={selectedFlightInfo}/>
                }
            case modalTypes.MTOW:
                return {
                    header: <FlightInfoHeaderGeneric selectedFlightInfo={selectedFlightInfo} />,
                    body: <MtowBody selectedFlightInfo={selectedFlightInfo} />
                }
            default:
                return {
                    header: <div></div>,
                    body: <div></div>
                }
        }
    }

    return (
        <div>
            <Dialog fullScreen open={show} onClose={handleClose}>
                <DialogTitle >  <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close" fontSize= {'inherit'}>
                    <CloseIcon />
                </IconButton>
                    <div className="clear"></div>
                    {comp(modalType).header}
                </DialogTitle>

                <DialogContent>
                    {comp(modalType).body}
                </DialogContent>

            </Dialog>

        </div>
    )
}

export default Parent